import moment from 'moment'
import store from 'store'
import { refreshClient } from '@opallabs/api'
import { registerAction } from '../../Action'
// import getToken from '../getToken';

const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN'

let expirationAlarm

const reducer = (state = {}, action) => ({
  ...state,
  api_access_token: action.payload,
})

const creator = ({ token, expiresAt }) => {
  if (expiresAt && token) {
    store.set('accessToken', token)
    store.set('accessTokenExpires', expiresAt)
    refreshClient()
    const expiration = moment(expiresAt)
    // if (moment().isAfter(expiration)) {
    //   return dispatch(getToken());
    // }
    if (expirationAlarm) {
      clearTimeout(expirationAlarm)
    }
    const timeUntilExpiration = expiration.diff(moment())
    console.info(
      `API access token expires in ${(timeUntilExpiration / 60000).toFixed(
        2
      )} minutes.`
    )
    // expirationAlarm = setTimeout(() => dispatch(getToken()), timeUntilExpiration);
    return token
  }
  return false
}

const setAccessToken = registerAction(SET_ACCESS_TOKEN, { reducer, creator })

export default setAccessToken
